//here i have written common grids for config module

import React from "react";
import { useState, useEffect } from "react";

import { Popconfirm, Space, Table, Menu, Dropdown, Button, Skeleton, Modal } from "antd";
import { DownOutlined } from '@ant-design/icons';

// import errorNew from "../../../assets/error/error.png";
import {
  QuestionCircleOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { ContextMenu } from "../components/Elements/ContextMenu";
import { useStoreUpdaterWithAPI } from "../Hooks/UseStoreUpdaterWithApi";
import { useSelector } from "react-redux";
import CustomHeader from "../components/Elements/CustomAgHeader";



//configuration start
export const GroupGrid = ({
  handleUpdatePopup,
  handleDeletePopup,
  handleDeleteSubmit,
  flowGroupList,
  groupModuleList,
  reportStatusList,
}) => {
  // //console.log(groupModuleList);

  const enhancedFlowGroupList = flowGroupList.map((item) => {
    const groupModule = groupModuleList.find(
      (module) => module.moduleID === item.groupModule
    );
    const reportStatus = reportStatusList.find(
      (status) => status.reportStatusID === item.reportStatus
    );

    return {
      ...item,
      groupModuleName: groupModule ? groupModule.moduleName : "Unknown Module",
      reportStatusName: reportStatus
        ? reportStatus.reportStatusName === "Yes"
          ? "Allow"
          : "Not Allow"
        : "Unknown Status",
    };
  });

  const flowGroupListWithAction = enhancedFlowGroupList.map((item) => ({
    ...item,
    actions: {
      update: handleUpdatePopup,
      delete: handleDeletePopup,
      confirmDelete: handleDeleteSubmit,
    },
  }));

  const columnDefs = [
    {
      headerName: "Group Name",
      field: "groupName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Group Module",
      field: "groupModuleName", 
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      headerComponent: CustomHeader, 
      headerComponentParams: {
        displayName: 'Group Module', 
      },
      flex: 2,
    },
    {
      headerName: "Report Status",
      field: "reportStatusName", 
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Action",
      headerClass: "grid-table-header",
      width: 50,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            <Button
              onClick={() => {
                params.data.actions.update(params.data);
              }}
            >
              <EditOutlined />
            </Button>

            <Popconfirm
              title="Delete the Group Meter"
              description="Are you sure to delete this Group Meter?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => {
                params.data.actions.confirmDelete(params.data.groupID); // to submit. handleDeleteSubmit
              }}
              trigger="click"
            >
              <Button className="text-red-500">
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
  };

  

  const { loading } = useStoreUpdaterWithAPI();
  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  return (
    <div className="App">
      <div
        className="ag-theme-alpine"
        style={{ height: "400px", width: "100%" }}
      >
        <AgGridReact
          columnDefs={columnDefs}
          rowData={flowGroupListWithAction}
          defaultColDef={defaultColDef}
          pagination={true}
          className = {`  ${isdarkMode ? 'custom-table-dark-group custom-table-dark-parameter' : 'whitemode'} `}
        />
      </div>
    </div>
  );
};

// Group Metr Grid
export const GroupMeterGrid = ({
  handleUpdatePopup,
  flowGroupMeterList = [],
  handleDeletePopup,
  handleDeleteSubmit,
  uspList = [],
}) => {
  // //console.log(flowGroupMeterList);
  const flowGroupMeterListName = flowGroupMeterList.map((item) => {
    const uspType = uspList.find(
      (module) => module.sitE_ID === item.converterID
    );
    return {
      ...item,
      uspList: uspType ? uspType.sitename : "Unknown Module",
    };
  });

  const flowGroupMeterListWithAction = flowGroupMeterListName.map((item) => ({
    ...item,
    actions: {
      update: handleUpdatePopup,
      delete: handleDeletePopup,
      confirmDelete: handleDeleteSubmit,
    },
  }));

  const columnDefs = [
    {
      headerName: "Group Name",
      field: "groupName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Sub Group Name",
      field: "subGroupName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Converter Name",
      field: "uspList",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Meter Name",
      field: "meterName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Action",
      headerClass: "grid-table-header",
      width: 50,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            <Button onClick={() => params.data.actions.update(params.data)}>
              <EditOutlined />
            </Button>
            <Popconfirm
              title="Delete the Group Meter"
              description="Are you sure to delete this Group Meter?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => {
                params.data.actions.confirmDelete(
                  params.data.groupMeterDetailID
                );
              }}
              trigger="click"
            >
              <Button className="text-red-500">
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
  };

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  return (
    <div className="App">
      <div
        className="ag-theme-alpine"
        style={{ height: "400px", width: "100%" }}
      >
        <AgGridReact
          columnDefs={columnDefs}
          rowData={flowGroupMeterListWithAction}
          defaultColDef={defaultColDef}
          pagination={true}
          className = {`  ${isdarkMode ? 'custom-table-dark-group custom-table-dark-parameter' : 'whitemode'} `}
        />
      </div>
    </div>
  );
};

//sub group
export const SubGroupGrid = ({
  handleUpdatePopup,
  flowSubGroupList,
  handleDeletePopup,
  handleDeleteSubmit,
  calculationTypeList,
  reportStatusList,
}) => {
  // //console.log(flowSubGroupList);
  // //console.log(reportStatusList);
  // //console.log(calculationTypeList);

  const flowSubGroupListName = flowSubGroupList.map((item) => {
    const calculationType = calculationTypeList.find(
      (module) => module.calculationTypeID === item.calculationTypeID
    );
    const reportStatus = reportStatusList.find(
      (status) => status.reportStatusID === item.reportStatus
    );
    // //console.log(calculationType);
    // //console.log(reportStatus);
    return {
      ...item,
      calculationTypeID: calculationType
        ? calculationType.calculationTypeName
        : "Unknown Module",
      reportStatus: reportStatus
        ? reportStatus.reportStatusName === "Yes"
          ? "Allow"
          : "Not Allow"
        : "Unknown Status",
    };
  });

  // //console.log(flowSubGroupListName)
  const flowGroupListWithAction = flowSubGroupListName.map((item) => ({
    ...item,
    actions: {
      update: handleUpdatePopup,
      delete: handleDeletePopup,
      confirmDelete: handleDeleteSubmit,
    },
  }));

  const columnDefs = [
    {
      headerName: "Group Name",
      field: "groupName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 1,
    },
    {
      headerName: "Sub Group Name",
      field: "subGroupName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 1,
    },
    {
      headerName: "Sub Group Type",
      field: "calculationTypeID",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 1,
    },
    {
      headerName: "Report Status",
      field: "reportStatus",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 1,
    },

    {
      headerName: "Action",
      headerClass: "grid-table-header",
      // width:50,

      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            <Button
              onClick={() => {
                // //console.log("Row Data:", params.data);
                params.data.actions.update(params.data);
              }}
            >
              <EditOutlined />
            </Button>
            <Popconfirm
              title="Delete the Group Meter"
              description="Are you sure to delete this Group Meter?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => {
                // //console.log("Row Data:", params.data);
                params.data.actions.confirmDelete(params.data.subGroupID); // to submit. handleDeleteSubmit
              }}
              trigger="click"
            >
              <Button className="text-red-500">
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
    // floatingFilter: true,
  };

  const mode = useSelector((state) => state.darkMode);

const { isdarkMode } = mode;

  return (
    <div className="App">
      <div
        className="ag-theme-alpine"
        style={{ height: "400px", width: "100%" }}
      >
        <AgGridReact
          columnDefs={columnDefs}
          rowData={flowGroupListWithAction}
          defaultColDef={defaultColDef}
          pagination={true}
          className = {`  ${isdarkMode ? 'custom-table-dark-group custom-table-dark-parameter' : 'whitemode'} `}
        />
      </div>
    </div>
  );
};

//configuration end

//Electrical start

//plant module

export const MainGrid = ({
  plantData,
  handleUpdateModel,
  handleDeleteModel,
  handleDeleteSubmit,
}) => {
  // //console.log(plantData);
  const plantDataWithAction = plantData.map((item) => ({
    ...item,
    actions: {
      update: handleUpdateModel,
      delete: handleDeleteModel,
      confirmDelete: handleDeleteSubmit,
    },
  }));

  // //console.log(plantData)
  const columnDefs = [
    {
      headerName: "Plant Name",
      field: "masterPlantName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Group Name",
      field: "detailGroupName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Graph Name",
      field: "detailControlName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Action",
      headerClass: "grid-table-header",
      width: 50,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            <Button
              onClick={() => {
                params.data.actions.update(params.data);
              }}
            >
              <EditOutlined />
            </Button>

            <Popconfirm
              title="Delete the Group Meter"
              description="Are you sure to delete this Group Meter?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => {
                ////console.log(params.data.detailPlantDetailID);
                params.data.actions.confirmDelete(
                  params.data.detailPlantDetailID
                ); // to submit. handleDeleteSubmit
              }}
              trigger="click"
            >
              <Button className="text-red-500">
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
  };

  return (
    <>
      <div className="App">
        <div
          className="ag-theme-alpine"
          style={{ height: "400px", width: "100%" }}
        >
          <AgGridReact
            columnDefs={columnDefs}
            rowData={plantDataWithAction}
            defaultColDef={defaultColDef}
            pagination={true}
          />
        </div>
      </div>
    </>
  );
};

//plant module second grid

export const SecondGrid = ({
  plantNameList,
  handlePlantDeleteModel,
  handleDeletePlantName,
}) => {
  ////console.log(plantNameList);
  const plantDataWithAction = plantNameList.map((item) => ({
    ...item,
    actions: {
      delete: handlePlantDeleteModel,
      confirmDelete: handleDeletePlantName,
    },
  }));

  // ////console.log(plantData)
  const columnDefs = [
    {
      headerName: "PlantId",
      field: "plantid",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Plant Name",
      field: "plantName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },

    {
      headerName: "Action",
      headerClass: "grid-table-header",
      width: 50,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            <Popconfirm
              title="Delete the Group Meter"
              description="Are you sure to delete this Group Meter?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => {
                params.data.actions.confirmDelete(params.data.plantid); // to submit. handleDeleteSubmit
              }}
              trigger="click"
            >
              <Button className="text-red-500">
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
  };

  return (
    <>
      <div className="App">
        <div
          className="ag-theme-alpine"
          style={{ height: "400px", width: "100%" }}
        >
          <AgGridReact
            columnDefs={columnDefs}
            rowData={plantDataWithAction}
            defaultColDef={defaultColDef}
            pagination={true}
          />
        </div>
      </div>
    </>
  );
};

// parameter view grid

export const ParameterViewGrid = (
  {
    // converterList
  }
) => {
  const columnDefs = [
    {
      headerName: "Meter Name",
      // field: "groupName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
      
    },
    {
      headerName: "Status",
      // field: "groupModuleName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "VR",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "VY",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "VB",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "F",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "VRY",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: "#e2e2e2" },
      width: 150,
    },
    {
      headerName: "VYB",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: "#e2e2e2" },
      width: 150,
    },
    {
      headerName: "VBR",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "VLLAvg",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "IR",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "IY",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "IB",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "IAVG",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "Vunb",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "lunb",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KWT",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KVAT",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KVART",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "PFT",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "PFR",
      field: "reportStatusName", // change to the new field name
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "PFY",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "PFB",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KWR",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KWY",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },

    {
      headerName: "KWB",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KVAR",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KVAY",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KVAB",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KVARR",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KVARY",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KVARB",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KWD",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KVAD",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KWHTotal",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KWHImport ",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KWHExpot",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "kVAH",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "kVArhTotal",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "kVArhinductive",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
    {
      headerName: "KVARHCAPACITIVE",
      // field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      width: 150,
    },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    filter: true,
    
  };

  const { loading } = useStoreUpdaterWithAPI();
  const mode = useSelector((state) => state.darkMode);

const { isdarkMode } = mode;

  return (
    <div className="App">
      <div
        className="ag-theme-alpine"
        style={{ height: "400px", width: "100%" }}
      >
        <AgGridReact
          scroll={{ x: "max-content" }}
          columnDefs={columnDefs}
          // rowData={converterList}
          defaultColDef={defaultColDef}
          pagination={true}
          alwaysShowHorizontalScroll={true}
          className = {`  ${isdarkMode ? 'custom-table-dark-parameter ' : 'whitemode'} `}
        />
      </div>
    </div>
  );
};


//Converter config grid in configuration 
// export const ConverterConfigGrid = ({
//  data,
//   handleDeleteSubmit,
//   refetch,
//   setRefetch
  
// }) => {
//   ////console.log(data)
  

//   const columnDefs = [
//     {
//       headerName: "S. No.",
//       field: "serialNo", 
//       cellRenderer: (params) => params.node.rowIndex + 1,
//       cellStyle: { borderRightColor: " #e2e2e2" },
      
//     },
    
//     {
//       headerName: "Converter Name",
//       field: "siteName",
//       cellStyle: { borderRightColor: " #e2e2e2" },
     
//     },
//     {
//       headerName: "Converter ID",
//       field: "siteID",
//       cellStyle: { borderRightColor: " #e2e2e2" },
    
//     },
//     {
//       headerName: "IP Address",
//       field: "siteIP", 
//       cellStyle: { borderRightColor: " #e2e2e2" },
     
//     },
//     {
//       headerName: "Port",
//       field: "port", 
//       cellStyle: { borderRightColor: " #e2e2e2" },
     
//     },
//     {
//       headerName: "No. of Ports",
//       field: "noofPorts",
//       cellStyle: { borderRightColor: " #e2e2e2" },
     
//     },
//     {
//       headerName: "Eletrical",
//       field: "isElectrical",
//       cellStyle: { borderRightColor: " #e2e2e2" },
//       cellDataType: "text", // Ensures values are displayed as-is
//       valueFormatter: null, // Prevents any formatting
     
//     },
//     {
//       headerName: "Temperature",
//       field: "isTemperature",
//       cellStyle: { borderRightColor: " #e2e2e2" },
//       cellDataType: "text", // Ensures values are displayed as-is
//       valueFormatter: null, // Prevents any formatting
//     },
//     {
//       headerName: "Air",
//       field: "isAir",
//       cellStyle: { borderRightColor: " #e2e2e2" },
//       cellDataType: "text", // Ensures values are displayed as-is
//       valueFormatter: null, // Prevents any formatting
//     },
//     {
//       headerName: "Water",
//       field: "isWater",
//       cellStyle: { borderRightColor: " #e2e2e2" },
//       cellDataType: "text", // Ensures values are displayed as-is
//       valueFormatter: null, // Prevents any formatting
//     },
//     {
//       headerName: "Steam",
//       field: "isSteam",
//       cellStyle: { borderRightColor: " #e2e2e2" },
//       cellDataType: "text", // Ensures values are displayed as-is
//       valueFormatter: null, // Prevents any formatting
//     },
//     // {
//     //   headerName: "Delete",
//     //   headerClass: "grid-table-header",
//     //   width: 100,
//     //   cellRenderer: (params) => {
//     //     return (
//     //       <div className="space-x-2">
//     //         {/* <Button
//     //           onClick={() => {
//     //             params.data.actions.update(params.data);
//     //           }}
//     //         >
//     //           <EditOutlined />
//     //         </Button> */}

//     //         <Popconfirm
//     //           title="Are you sure to delete this Converter"
//     //           // description="Are you sure to delete this Converter Configuration?"
//     //           icon={<QuestionCircleOutlined style={{ color: "red" }} />}
//     //           onConfirm={() => handleDeleteSubmit(params.data.siteID)}
//     //           trigger="click"
//     //         >
//     //           <Button className="text-red-500">
//     //             <DeleteOutlined />
//     //           </Button>
//     //         </Popconfirm>
//     //       </div>
//     //     );
//     //   },
//     // },
//   ];

//   const defaultColDef = {
//     sortable: true,
//     // editable: true,
//     width: 170,
//   };

//   const mode = useSelector((state) => state.darkMode);

//   const { isdarkMode } = mode;
//   const color = useSelector((state) => state.ThemeChange);
//   //console.log(color)

//   return (
//     <div className="App">
//       <div
//         className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`} 
//         style={{
//           '--ag-header-background-color': color.themeConfig.colorPrimary, 
//           '--ag-header-foreground-color': '#fff', 
//           height: "400px", width: "100%", overflowY: "auto" 
//         }}
//         // style={{ height: "400px", width: "100%" ,overflowX:'auto'}}
//       >
//         <AgGridReact
//           columnDefs={columnDefs}
//           rowData={data} 
//           defaultColDef={defaultColDef}
//           pagination={true}
//           // className = {`  ${isdarkMode ? 'custom-table-dark-group custom-table-dark-parameter' : 'whitemode'} `}
//           // className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}  ag-theme-alpine-custom`}
//           domLayout="autoHeight"
//         />
//       </div>
//     </div>
//   );
// };
export const ConverterConfigGrid = ({
 data,
  handleDeleteSubmit,
  refetch,
  setRefetch,
  selectedMeterID,
  setSelectedMeterID,
  
}) => {
  //console.log(data)
  

  const columnDefs = [
      {
    headerCheckboxSelection: true, 
    checkboxSelection: true,      
    width: 50,
    headerName: "",                
    field: "check",             
    pinned: "left",
    // cellStyle: { borderRightColor: " #e2e2e2" },
  },
    {
      headerName: "S. No.",
      field: "serialNo", 
      cellRenderer: (params) => params.node.rowIndex + 1,
      cellStyle: { borderRightColor: " #e2e2e2" },
      
    },
    
    {
      headerName: "Converter Name",
      field: "siteName",
      cellStyle: { borderRightColor: " #e2e2e2" },
     
    },
    {
      headerName: "Converter ID",
      field: "siteID",
      cellStyle: { borderRightColor: " #e2e2e2" },
    
    },
    {
      headerName: "IP Address",
      field: "siteIP", 
      cellStyle: { borderRightColor: " #e2e2e2" },
     
    },
    {
      headerName: "Port",
      field: "port", 
      cellStyle: { borderRightColor: " #e2e2e2" },
     
    },
    {
      headerName: "No. of Ports",
      field: "noofPorts",
      cellStyle: { borderRightColor: " #e2e2e2" },
     
    },
    {
      headerName: "Eletrical",
      field: "isElectrical",
      cellStyle: { borderRightColor: " #e2e2e2" },
      cellDataType: "text", // Ensures values are displayed as-is
      valueFormatter: null, // Prevents any formatting
     
    },
    {
      headerName: "Temperature",
      field: "isTemperature",
      cellStyle: { borderRightColor: " #e2e2e2" },
      cellDataType: "text", // Ensures values are displayed as-is
      valueFormatter: null, // Prevents any formatting
    },
    {
      headerName: "Air",
      field: "isAir",
      cellStyle: { borderRightColor: " #e2e2e2" },
      cellDataType: "text", // Ensures values are displayed as-is
      valueFormatter: null, // Prevents any formatting
    },
    {
      headerName: "Water",
      field: "isWater",
      cellStyle: { borderRightColor: " #e2e2e2" },
      cellDataType: "text", // Ensures values are displayed as-is
      valueFormatter: null, // Prevents any formatting
    },
    {
      headerName: "Steam",
      field: "isSteam",
      cellStyle: { borderRightColor: " #e2e2e2" },
      cellDataType: "text", // Ensures values are displayed as-is
      valueFormatter: null, // Prevents any formatting
    },
    // {
    //   headerName: "Delete",
    //   headerClass: "grid-table-header",
    //   width: 100,
    //   cellRenderer: (params) => {
    //     return (
    //       <div className="space-x-2">
    //         {/* <Button
    //           onClick={() => {
    //             params.data.actions.update(params.data);
    //           }}
    //         >
    //           <EditOutlined />
    //         </Button> */}

    //         <Popconfirm
    //           title="Are you sure to delete this Converter"
    //           // description="Are you sure to delete this Converter Configuration?"
    //           icon={<QuestionCircleOutlined style={{ color: "red" }} />}
    //           onConfirm={() => handleDeleteSubmit(params.data.siteID)}
    //           trigger="click"
    //         >
    //           <Button className="text-red-500">
    //             <DeleteOutlined />
    //           </Button>
    //         </Popconfirm>
    //       </div>
    //     );
    //   },
    // },
  ];

  const defaultColDef = {
    sortable: true,
    // editable: true,
    width: 170,
  };

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  const color = useSelector((state) => state.ThemeChange);
  // //console.log(color)
  const onSelectionChanged = (event) => {
  const selectedRows = event.api.getSelectedRows();
  setSelectedMeterID(selectedRows.map(row => row.siteID)); 
  // //console.log("Selected Row(s):", selectedRows);
};


  return (
    <div className="App">
      <div
        className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`} 
        style={{
          '--ag-header-background-color': color.themeConfig.colorPrimary, 
          '--ag-header-foreground-color': '#fff', 
          height: "300px", width: "100%", overflowY: "auto" 
        }}
        // style={{ height: "400px", width: "100%" ,overflowX:'auto'}}
      >
        <AgGridReact
          columnDefs={columnDefs}
          rowData={data} 
          defaultColDef={defaultColDef}
          // pagination={true}
          // className = {`  ${isdarkMode ? 'custom-table-dark-group custom-table-dark-parameter' : 'whitemode'} `}
          // className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}  ag-theme-alpine-custom`}
          domLayout="normal"
                  // rowHeight={50}
          onSelectionChanged={onSelectionChanged}
        />
      </div>
    </div>
  );
};


export const MeterConfigGrid = ({
  handleDeleteSubmit,
  data, 
  setIsUpdate,
  handleUpdate,
  setRefetch,
  refetch,
}) => {
  //console.log(data);
  const color = useSelector((state) => state.ThemeChange);
  //console.log(color)

  // Meter Config in configuration
  const columnDefs = [
      {
      headerName: "Action",
      width: 180,
      cellStyle: { borderRightColor: "#e2e2e2" },
      cellRenderer: (params) => {
        //console.log("Params :", params);
        const actions = params.data?.actions;
        //console.log("Action :", actions);
        //console.log(params.data);
        return (
          <div className="space-x-4">
             <span
  className="text-green-500 bg-green-200 p-2 cursor-pointer shadow-lg rounded-md px-4 
             transition-transform duration-200 hover:border-[1px] border-green-400"
              onClick={() => {
                if (actions && actions.update) {
                  //console.log(params.data)
                  setIsUpdate();
                  setRefetch(!refetch);
                  handleUpdate(params.data)
                  actions.update(params.data);
                }
              }}
            >
              <EditOutlined />
            </span>
            {/* <Button
              className="text-red-500"
              onClick={() =>
                handleDeleteSubmit(
                  params.data.meterid,
                  params.data.departmenT_ID,
                  params.data.sitE_ID
                )
              }
            >
              <DeleteOutlined />
            </Button> */}

            <Popconfirm
              title="Are you sure to delete this device"
              // description="Are you sure to delete this Converter Configuration?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() =>   handleDeleteSubmit(
                params.data.meteR_METERID,
                params.data.departmenT_ID,
                params.data.sitE_ID
              )}
              trigger="click"
            >
            <span
  className="text-red-500 bg-red-200 p-2 cursor-pointer shadow-lg rounded-md px-4 
             transition-transform duration-200 hover:border-[1px] border-red-400">
  <DeleteOutlined />
</span>


            </Popconfirm>
          </div>
        );
      },
    },
    {
      headerName: "S.NO",
      cellStyle: { borderRightColor: "#e2e2e2" },
      cellRenderer: (params) => {
        const serialNumber = params.rowIndex + 1;
        return serialNumber;
      },
      width: 90,
    },
    // {
    //   headerName: "Converter ID",
    //   field: "sitE_ID",
    //   width: 150,
    //   cellStyle: { borderRightColor: "#e2e2e2" },
    // },
    {
      headerName: "ConverterName",
      field: "sitename",
      width: 180,
      cellStyle: { borderRightColor: "#e2e2e2" },
    },
    {
      headerName: "Device ID",
      field: "meteR_METERID",
      width: 180,
      cellStyle: { borderRightColor: "#e2e2e2" },
    },
    {
      headerName: "Device Name",
      field: "metername",
      width: 180,
      cellStyle: { borderRightColor: "#e2e2e2" },
    },
    {
      headerName: "Device Model",
      field: "metermodel",
      width: 180,
      cellStyle: { borderRightColor: "#e2e2e2" },
    },
    {
      headerName: "Module",
      field: "module",
      width: 180,
      cellStyle: { borderRightColor: "#e2e2e2" },
    },
    {
      headerName: "Device Supplier",
      field: "meterSupplier",
      width: 180,
      cellStyle: { borderRightColor: "#e2e2e2" },
    },
    {
      headerName: "IP Address",
      field: "ipAddress",
      width: 180,
      cellStyle: { borderRightColor: "#e2e2e2" },
    },
    {
      headerName: "Port No.",
      field: "portNo",
      width: 180,
      cellStyle: { borderRightColor: "#e2e2e2" },
    },
  
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    // width:300,
    filter: true,
  };

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  return (
    <div
    className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
      style={{
        '--ag-header-background-color': color.themeConfig.colorPrimary, 
        '--ag-header-foreground-color': '#fff', 
        height: "400px", width: "100%", overflowY: "auto" 
      }}
      // style={{ height: "400px", width: "100%",overflowX:"auto" }}
    >
      <AgGridReact
        columnDefs={columnDefs}
        rowData={data}
        // defaultColDef={defaultColDef}
        pagination={true}
        // className={`${
        //   isdarkMode
        //     ? "custom-table-dark-group custom-table-dark-parameter"
        //     : "whitemode"
        // }`}
        // className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}  ag-theme-alpine-custom`}
        domLayout="normal"
        // rowHeight={50}
      />
    </div>
  );
};


export const UserConfigGrid = ({

  handleDeletePopup,
  handleDeleteSubmit,
 
}) => {
  



  const columnDefs = [
   
    {
      headerName: "UserName",
      field: "groupModuleName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "FirstName",
      field: "reportStatusName", 
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Designation",
      field: "groupModuleName", 
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Admin",
      field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "EmailID",
      field: "reportStatusName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    // {
    //   headerName: "Action",
    //   headerClass: "grid-table-header",
    //   width: 50,
    //   cellRenderer: (params) => {
    //     return (
    //       <div className="space-x-2">
    //         <Button
    //           onClick={() => {
    //             params.data.actions.update(params.data);
    //           }}
    //         >
    //           <EditOutlined />
    //         </Button>

    //         <Popconfirm
    //           title="Delete  Converter Configuration"
    //           description="Are you sure to delete this Converter Configuration?"
    //           icon={<QuestionCircleOutlined style={{ color: "red" }} />}
    //           onConfirm={() => {
    //             params.data.actions.confirmDelete(params.data.groupID); // to submit. handleDeleteSubmit
    //           }}
    //           trigger="click"
    //         >
    //           <Button className="text-red-500">
    //             <DeleteOutlined />
    //           </Button>
    //         </Popconfirm>
    //       </div>
    //     );
    //   },
    // },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
  };

  const { loading } = useStoreUpdaterWithAPI();
  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  return (
    <div className="App">
      <div
        className="ag-theme-alpine"
        style={{ height: "400px", width: "100%" }}
      >
        <AgGridReact 
          columnDefs={columnDefs}
          // rowData={flowGroupListWithAction}
          defaultColDef={defaultColDef}
          pagination={true}
          // className = {`  ${isdarkMode ? 'custom-table-dark-group custom-table-dark-parameter' : 'whitemode'} `}
          className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}  ag-theme-alpine-custom`}
        />
      </div>
    </div>
  );
};
export const ManualEntryGrid = ({
 data,
  handleDeletePopup,
  handleDeleteSubmit,
 
}) => {
  

//console.log(data)

  // const columnDefs = [
  //   {
  //     headerName: "IEXGDAM",
  //     field: "iexgdam",
  //     headerClass: "grid-table-header",
  //     cellStyle: { borderRightColor: "#e2e2e2" },
  //     flex: 2,
  //   },
  //   {
  //     headerName: "IEXDAM And RTM",
  //     field: "iexdamAndRTM",
  //     headerClass: "grid-table-header",
  //     cellStyle: { borderRightColor: "#e2e2e2" },
  //     flex: 2,
  //   },
  //   {
  //     headerName: "Wind",
  //     field: "wind",
  //     headerClass: "grid-table-header",
  //     cellStyle: { borderRightColor: "#e2e2e2" },
  //     flex: 2,
  //   },
  //   {
  //     headerName: "Solar",
  //     field: "solar",
  //     headerClass: "grid-table-header",
  //     cellStyle: { borderRightColor: "#e2e2e2" },
  //     flex: 2,
  //   },
  //   {
  //     headerName: "Sand Unit One",
  //     field: "sandUnitOne",
  //     headerClass: "grid-table-header",
  //     cellStyle: { borderRightColor: "#e2e2e2" },
  //     flex: 2,
  //   },
  //   {
  //     headerName: "Sand Unit Two",
  //     field: "sandUnitTwo",
  //     headerClass: "grid-table-header",
  //     cellStyle: { borderRightColor: "#e2e2e2" },
  //     flex: 2,
  //   },
  //   {
  //     headerName: "Investment",
  //     field: "investment",
  //     headerClass: "grid-table-header",
  //     cellStyle: { borderRightColor: "#e2e2e2" },
  //     flex: 2,
  //   },
  //   {
  //     headerName: "SKO Sand",
  //     field: "skoSand",
  //     headerClass: "grid-table-header",
  //     cellStyle: { borderRightColor: "#e2e2e2" },
  //     flex: 2,
  //   },
  //   {
  //     headerName: "SKO Investment",
  //     field: "skoInvestment",
  //     headerClass: "grid-table-header",
  //     cellStyle: { borderRightColor: "#e2e2e2" },
  //     flex: 2,
  //   },
  //   {
  //     headerName: "HSD Sand",
  //     field: "hsdSand",
  //     headerClass: "grid-table-header",
  //     cellStyle: { borderRightColor: "#e2e2e2" },
  //     flex: 2,
  //   },
  //   {
  //     headerName: "HSD Investment",
  //     field: "hsdInvestment",
  //     headerClass: "grid-table-header",
  //     cellStyle: { borderRightColor: "#e2e2e2" },
  //     flex: 2,
  //   },
  //   {
  //     headerName: "LPG Sand",
  //     field: "lpgSand",
  //     headerClass: "grid-table-header",
  //     cellStyle: { borderRightColor: "#e2e2e2" },
  //     flex: 2,
  //   },
  //   {
  //     headerName: "Created On",
  //     field: "createdOn",
  //     headerClass: "grid-table-header",
  //     cellStyle: { borderRightColor: "#e2e2e2" },
  //     flex: 2,
  //   },
  //   {
  //     headerName: "Action",
  //     headerClass: "grid-table-header",
  //     width: 180,
  //     cellRenderer: (params) => {
  //       //console.log("Params :", params);
  //       const actions = params.data?.actions;
  //       //console.log("Action :", actions);
  //       //console.log(params.data);
  //       return (
  //         <div className="space-x-2">
  //           {/* <Button
  //             onClick={() => {
  //               if (actions && actions.update) {
  //                 //console.log(params.data)
  //                 actions.update(params.data);
  //               }
  //             }}
  //           >
  //             <EditOutlined />
  //           </Button> */}
           

  //           <Popconfirm
  //             title="Are you sure to delete this Converter"
  //             // description="Are you sure to delete this Converter Configuration?"
  //             icon={<QuestionCircleOutlined style={{ color: "red" }} />}
  //             onConfirm={() =>   handleDeleteSubmit(
  //               params.data
  //             )}
  //             trigger="click"
  //           >
  //             <Button
  //             className="text-red-500">
  //             <DeleteOutlined />
  //           </Button>
  //           </Popconfirm>
  //         </div>
  //       );
  //     },
  //   },
  //   // {
  //   //   headerName: "Action",
  //   //   headerClass: "grid-table-header",
  //   //   width: 100,
  //   //   cellRenderer: (params) => {
  //   //     return (
  //   //       <div className="space-x-2">
  //   //         {/* Update Button */}
  //   //         <Button
  //   //           onClick={() => {
  //   //             params.data.actions.update(params.data);
  //   //           }}
  //   //           className="text-blue-500"
  //   //         >
  //   //           <EditOutlined />
  //   //         </Button>
  
  //   //         {/* Delete Confirmation */}
  //   //         <Popconfirm
  //   //           title="Delete Entry"
  //   //           description="Are you sure you want to delete this entry?"
  //   //           icon={<QuestionCircleOutlined style={{ color: "red" }} />}
  //   //           onConfirm={() => {
  //   //             params.data.actions.confirmDelete(params.data.id);
  //   //           }}
  //   //           trigger="click"
  //   //         >
  //   //           <Button className="text-red-500">
  //   //             <DeleteOutlined />
  //   //           </Button>
  //   //         </Popconfirm>
  //   //       </div>
  //   //     );
  //   //   },
  //   // },
  // ];
  

  const columnDefs = [
    { headerName: " Unit-1 Grid", field: "unit1Grid", flex:2,  minWidth:120,  cellStyle: { borderRightColor: "#e2e2e2" } },
    { headerName: "Unit-1 IEX GDAM", field: "unit1IEXGDAM", flex: 2,minWidth:160,  cellStyle: { borderRightColor: "#e2e2e2" } },
    { headerName: "Unit-1 IEX - DAM & RTM", field: "unit1IEXDAMAndRTM", flex: 2,minWidth:210,  cellStyle: { borderRightColor: "#e2e2e2" } },
    { headerName: "Unit-1 Wind", field: "unit1Wind", flex: 2,minWidth:130,  cellStyle: { borderRightColor: "#e2e2e2" } },
    { headerName: "Unit-1 Solar", field: "unit1Solar", flex: 2,minWidth:130,  cellStyle: { borderRightColor: "#e2e2e2" } },
    { headerName: "Unit-2 Grid", field: "unit2Grid", flex: 2,minWidth:120,  cellStyle: { borderRightColor: "#e2e2e2" } },
    { headerName: "Unit-2 IEX GDAM", field: "unit2IEXGDAM", flex: 2,minWidth:160,  cellStyle: { borderRightColor: "#e2e2e2" } },
    { headerName: "Unit-2 IEX DAM & RTM", field: "unit2IEXDAMAndRTM", flex: 2,minWidth:200,  cellStyle: { borderRightColor: "#e2e2e2" } },
    { headerName: "Unit-2 Wind", field: "unit2Wind", flex: 2,minWidth:130,  cellStyle: { borderRightColor: "#e2e2e2" } },
    { headerName: "Unit-2 Solar", field: "unit2Solar", flex: 2,minWidth:130,  cellStyle: { borderRightColor: "#e2e2e2" } },
    { headerName: "Unit-1 Production", field: "unit1Production", flex: 2,minWidth:170,  cellStyle: { borderRightColor: "#e2e2e2" } },
    { headerName: "Unit-1 Rejection", field: "unit1Rejection", flex: 2,minWidth:170,  cellStyle: { borderRightColor: "#e2e2e2" } },
    { headerName: "Unit-2 Production", field: "unit2Production", flex: 2,minWidth:170,  cellStyle: {  borderRightColor: "#e2e2e2" } },
    { headerName: "Unit-2 Rejection", field: "unit2Rejection", flex: 2,minWidth:170,  cellStyle: { borderRightColor: "#e2e2e2" } },
    { headerName: "Investment Production", field: "investmentProduction", flex: 2,minWidth:200,  cellStyle: { borderRightColor: "#e2e2e2" } },
    { headerName: "Investment Rejection", field: "investmentRejection", flex: 2,minWidth:200,  cellStyle: { borderRightColor: "#e2e2e2" } },
    { headerName: "Sand Unit - HSD (L)", field: "sandUnitHSD", flex: 2,minWidth:200,  cellStyle: { borderRightColor: "#e2e2e2" } },
    { headerName: "Sand Unit - SKO (L)", field: "sandUnitSKO", flex: 2,minWidth:200,  cellStyle: { borderRightColor: "#e2e2e2" } },
    { headerName: "Sand Unit - LPG (kg)", field: "sandUnitLPG", flex: 2,minWidth:200,  cellStyle: { borderRightColor: "#e2e2e2" } },
    { headerName: "Investment - HSD (L)", field: "investmentHSD", flex: 2,minWidth:200,  cellStyle: { borderRightColor: "#e2e2e2" } },
    { headerName: "Investment - SKO (L)", field: "investmentSKO", flex: 2,minWidth:200,  cellStyle: { borderRightColor: "#e2e2e2" } },
    { headerName: "Created On", field: "createdOn", flex: 2,minWidth:200,  cellStyle: { borderRightColor: "#e2e2e2" } },
    {
      headerName: "Action",
      width: 180,
      
      cellRenderer: (params) => (
        <div className="space-x-2">
          <Popconfirm
            title="Are you sure to delete this entry?"
            icon={<QuestionCircleOutlined style={{ color: "red" }} />}
            onConfirm={() => handleDeleteSubmit(params.data)}
            trigger="click"
          >
            <Button className="text-red-500">
              <DeleteOutlined />
            </Button>
          </Popconfirm>
        </div>
      ),
    },
  ];
  
   

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    minWidth:170,
    filter: true,
  };

  const { loading } = useStoreUpdaterWithAPI();
  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  const color = useSelector((state) => state.ThemeChange);
  //console.log(color)

  return (
    <div className="App"> 
      <div
        className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
        style={{
          '--ag-header-background-color': color.themeConfig.colorPrimary, 
          '--ag-header-foreground-color': '#fff', 
          height: "700px", width: "100%", overflowY: "auto" 
        }}
        // style={{ height: "400px", width: "100%" }}
      >
        <AgGridReact 
          columnDefs={columnDefs}
          rowData={data}
          defaultColDef={defaultColDef}
          pagination={true}
          // className = {`  ${isdarkMode ? 'custom-table-dark-group custom-table-dark-parameter' : 'whitemode'} `}
          // className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}  ag-theme-alpine-custom`}
        />
      </div>
    </div>
  );
};

export const EmissionFactorGrid = ({
 data,
  handleDeletePopup,
  handleDeleteSubmit,
 
}) => {
  

//console.log(data)


const columnDefs = [
  { headerName: "Electrical Energy", field: "electricalEnergy", flex: 2, minWidth:170,  cellStyle: { borderRightColor: "#e2e2e2" } },
  { headerName: "HSD", field: "hsd", flex: 2, minWidth:100,  cellStyle: { borderRightColor: "#e2e2e2" } },
  { headerName: "SKO", field: "sko", flex: 2, minWidth:100,  cellStyle: { borderRightColor: "#e2e2e2" } },
  { headerName: "LPG", field: "lpg", flex: 2, minWidth:100,  cellStyle: { borderRightColor: "#e2e2e2" } },
  { headerName: "SMML Plant", field: "smmlPlant", flex: 2, minWidth:150,  cellStyle: { borderRightColor: "#e2e2e2" } },
  { headerName: "Sand Unit-1", field: "sandUnit1", flex: 2, minWidth:150,  cellStyle: { borderRightColor: "#e2e2e2" } },
  { headerName: "Sand Unit-2", field: "sandUnit2", flex: 2, minWidth:150,  cellStyle: { borderRightColor: "#e2e2e2" } },
  { headerName: "Investment", field: "investment", flex: 2, minWidth:150,  cellStyle: { borderRightColor: "#e2e2e2" } },
  { headerName: "Sand Foundry 1 - Melting", field: "sandFoundry1Melting", flex: 2, minWidth:230,  cellStyle: { borderRightColor: "#e2e2e2" } },
  { headerName: "Sand Foundry 1 - Air Compressor", field: "sandFoundry1AirCompressor", flex: 2, minWidth:260,  cellStyle: { borderRightColor: "#e2e2e2" } },
  { headerName: "Sand Foundry 1 - Electrical HTF", field: "sandFoundry1ElectricalHTF", flex: 2, minWidth:250,  cellStyle: { borderRightColor: "#e2e2e2" } },
  { headerName: "Sand Foundry 1 - Thermal", field: "sandFoundry1Thermal", flex: 2, minWidth:250,  cellStyle: { borderRightColor: "#e2e2e2" } },
  { headerName: "Sand Foundry 1 - Fettling", field: "sandFoundry1Fettling", flex: 2, minWidth:230,  cellStyle: { borderRightColor: "#e2e2e2" } },
  { headerName: "Sand Foundry 1 - Others", field: "sandFoundry1Others", flex: 2, minWidth:250,  cellStyle: { borderRightColor: "#e2e2e2" } },
  { headerName: "Sand Foundry 2 - Melting", field: "sandFoundry2Melting", flex: 2, minWidth:250,  cellStyle: { borderRightColor: "#e2e2e2" } },
  { headerName: "Sand Foundry 2 - Air Compressor", field: "sandFoundry2AirCompressor", flex: 2, minWidth:270,  cellStyle: { borderRightColor: "#e2e2e2" } },
  { headerName: "Sand Foundry 2 - Fettling 1st Stage", field: "sandFoundry2Fettling1Stage", flex: 2, minWidth:270,  cellStyle: { borderRightColor: "#e2e2e2" } },
  { headerName: "Sand Foundry 2 - Shed C Fettling", field: "sandFoundry2ShedCFettling", flex: 2, minWidth:270,  cellStyle: { borderRightColor: "#e2e2e2" } },
  { headerName: "Sand Foundry 2 - Pump", field: "sandFoundry2Pump", flex: 2, minWidth:200,  cellStyle: { borderRightColor: "#e2e2e2" } },
  { headerName: "Sand Foundry 2 - Other", field: "sandFoundry2Other", flex: 2, minWidth:220,  cellStyle: { borderRightColor: "#e2e2e2" } },
  { headerName: "Investment - Melting", field: "investmentMelting", flex: 2, minWidth:190,  cellStyle: { borderRightColor: "#e2e2e2" } },
  { headerName: "Investment - Wax & Shelling", field: "investmentWaxAndShelling", flex: 2, minWidth:240,  cellStyle: { borderRightColor: "#e2e2e2" } },
  { headerName: "Investment - AC Plant", field: "investmentACPlant", flex: 2, minWidth:190,  cellStyle: { borderRightColor: "#e2e2e2" } },
  { headerName: "Investment - HT Furnace", field: "investmentHTFurnace", flex: 2, minWidth:220,  cellStyle: { borderRightColor: "#e2e2e2" } },
  { headerName: "Investment - Melting Pumps", field: "investmentMeltingPumps", flex: 2, minWidth:250,  cellStyle: { borderRightColor: "#e2e2e2" } },
  { headerName: "Investment - Other", field: "investmentOther", flex: 2, minWidth:190,  cellStyle: { borderRightColor: "#e2e2e2" } },
  // { headerName: "Modified On", field: "modifiedOn", flex: 2, minWidth:120,  cellStyle: { borderRightColor: "#e2e2e2" } },
  // {
  //   headerName: "Action",
  //   width: 180,
  //   headerClass: "grid-table-header",
  //   cellRenderer: (params) => (
  //     <div className="space-x-2">
  //       <Popconfirm
  //         title="Are you sure to delete this entry?"
  //         icon={<QuestionCircleOutlined style={{ color: "red" }} />}
  //         onConfirm={() => handleDeleteSubmit(params.data)}
  //         trigger="click"
  //       >
  //         <Button className="text-red-500">
  //           <DeleteOutlined />
  //         </Button>
  //       </Popconfirm>
  //     </div>
  //   ),
  // },
];


  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    minWidth:170,
    filter: true,
  };

  const { loading } = useStoreUpdaterWithAPI();
  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  const color = useSelector((state) => state.ThemeChange);
  //console.log(color)
  return (
    <div className="App">
      <div
        className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
        style={{
          '--ag-header-background-color': color.themeConfig.colorPrimary, 
          '--ag-header-foreground-color': '#fff', 
          height: "400px", width: "100%", overflowY: "auto" 
        }}
        // style={{ height: "400px", width: "100%" }}
      >
        <AgGridReact 
          columnDefs={columnDefs}
          rowData={data}
          defaultColDef={defaultColDef}
          pagination={true}
          // className = {`  ${isdarkMode ? 'custom-table-dark-group custom-table-dark-parameter' : 'whitemode'} `}
          // className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}  ag-theme-alpine-custom`}
        />
      </div>
    </div>
  );
};



//steam sub group grid
export const SteamSubGroupGrid = ({

  handleDeletePopup,
  handleDeleteSubmit,
 
}) => {
  


 

  const columnDefs = [
    {
      headerName: "Group",
      field: "groupName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Sub Group",
      field: "groupModuleName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "SubGroup Type",
      field: "reportStatusName", 
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Report Status",
      field: "groupModuleName", 
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
   
    {
      headerName: "Action",
      headerClass: "grid-table-header",
      width: 50,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            <Button
              onClick={() => {
                params.data.actions.update(params.data);
              }}
            >
              <EditOutlined />
            </Button>

            <Popconfirm
              title="Delete  Converter Configuration"
              description="Are you sure to delete this Converter Configuration?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => {
                params.data.actions.confirmDelete(params.data.groupID); // to submit. handleDeleteSubmit
              }}
              trigger="click"
            >
              <Button className="text-red-500">
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
  };

  const { loading } = useStoreUpdaterWithAPI();
  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  return (
    <div className="App">
      <div
        className="ag-theme-alpine"
        style={{ height: "400px", width: "100%" }}
      >
        <AgGridReact
          columnDefs={columnDefs}
          // rowData={flowGroupListWithAction}
          defaultColDef={defaultColDef}
          pagination={true}
          className = {`  ${isdarkMode ? 'custom-table-dark-group custom-table-dark-parameter' : 'whitemode'} `}
        />
      </div>
    </div>
  );
};

export const SteamGroupMeterGrid = ({
  
}) => {
 

  const columnDefs = [
    {
      headerName: "Group Name",
      field: "groupName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Sub Group Name",
      field: "subGroupName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Converter Name",
      field: "uspList",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Meter Name",
      field: "meterName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Action",
      headerClass: "grid-table-header",
      width: 50,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            <Button onClick={() => params.data.actions.update(params.data)}>
              <EditOutlined />
            </Button>
            <Popconfirm
              title="Delete the Group Meter"
              description="Are you sure to delete this Group Meter?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => {
                params.data.actions.confirmDelete(
                  params.data.groupMeterDetailID
                );
              }}
              trigger="click"
            >
              <Button className="text-red-500">
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
  };

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  return (
    <div className="App">
      <div
        className="ag-theme-alpine"
        style={{ height: "400px", width: "100%" }}
      >
        <AgGridReact
          columnDefs={columnDefs}
          // rowData={flowGroupMeterListWithAction}
          defaultColDef={defaultColDef}
          pagination={true}
          className = {`  ${isdarkMode ? 'custom-table-dark-group custom-table-dark-parameter' : 'whitemode'} `}
        />
      </div>
    </div>
  );
};



export const WaterSubGroupGrid = ({

  handleDeletePopup,
  handleDeleteSubmit,
 
}) => {
  


 

  const columnDefs = [
    {
      headerName: "Group",
      field: "groupName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Sub Group",
      field: "groupModuleName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "SubGroup Type",
      field: "reportStatusName", 
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Report Status",
      field: "groupModuleName", 
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
   
    {
      headerName: "Action",
      headerClass: "grid-table-header",
      width: 50,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            <Button
              onClick={() => {
                params.data.actions.update(params.data);
              }}
            >
              <EditOutlined />
            </Button>

            <Popconfirm
              title="Delete  Converter Configuration"
              description="Are you sure to delete this Converter Configuration?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => {
                params.data.actions.confirmDelete(params.data.groupID); // to submit. handleDeleteSubmit
              }}
              trigger="click"
            >
              <Button className="text-red-500">
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
  };

  const { loading } = useStoreUpdaterWithAPI();
  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  return (
    <div className="App">
      <div
        className="ag-theme-alpine"
        style={{ height: "400px", width: "100%" }}
      >
        <AgGridReact
          columnDefs={columnDefs}
          // rowData={flowGroupListWithAction}
          defaultColDef={defaultColDef}
          pagination={true}
          className = {`  ${isdarkMode ? 'custom-table-dark-group custom-table-dark-parameter' : 'whitemode'} `}
        />
      </div>
    </div>
  );
};

export const WaterGroupMeterGrid = ({
  
}) => {
 

  const columnDefs = [
    {
      headerName: "Group Name",
      field: "groupName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Sub Group Name",
      field: "subGroupName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Converter Name",
      field: "uspList",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Meter Name",
      field: "meterName",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex: 2,
    },
    {
      headerName: "Action",
      headerClass: "grid-table-header",
      width: 50,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            <Button onClick={() => params.data.actions.update(params.data)}>
              <EditOutlined />
            </Button>
            <Popconfirm
              title="Delete the Group Meter"
              description="Are you sure to delete this Group Meter?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => {
                params.data.actions.confirmDelete(
                  params.data.groupMeterDetailID
                );
              }}
              trigger="click"
            >
              <Button className="text-red-500">
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
  };

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  return (
    <div className="App">
      <div
        className="ag-theme-alpine"
        style={{ height: "400px", width: "100%" }}
      >
        <AgGridReact
          columnDefs={columnDefs}
          // rowData={flowGroupMeterListWithAction}
          defaultColDef={defaultColDef}
          pagination={true}
          className = {`  ${isdarkMode ? 'custom-table-dark-group custom-table-dark-parameter' : 'whitemode'} `}
        />
      </div>
    </div>
  );
};